import { useNavigate } from "react-router-dom";
import "./SubscribeNow.scss";
import { useEffect } from "react";

const SubscribeNow = ({ info }: any) => {
    const navigate=useNavigate();
    const scrollToSection = (sectionId:any) => {
      setTimeout(() => {
        const targetElement = document.getElementById(sectionId);
        if (targetElement) {
          const offset = 60;
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - offset;
  
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 500);
    };
  
    const onClickSubscribeNow = () => {
      navigate('//#pricing-section');
      scrollToSection("pricing-section");
    };
  
    const onClickFreeTrial = () => {
      navigate('//#free-trial');
      scrollToSection("free-trial");
    };
     return (
        <div className="subscribe-container">
          <h4 className="subscribe-heading">Subscribe Today To Access</h4>
          <p className="subscribe-text">
            This access is not covered in your present subscription plan
          </p>
          <button className="subscribe-btn mb-0" onClick={onClickSubscribeNow}>
            Subscribe Now
          </button>
         {info.message !== "PLAN_EXPIRED" && (
           <>
             <p className="or-text">or</p>
             <button className="trial-btn" onClick={onClickFreeTrial}>
               Start 7 Days Free Trial
             </button>
           </>
         )}
        </div>
      );
}
export default SubscribeNow;